import { useEffect, useState } from "react";
import axios from "axios";
import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "@/i18n/LangContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PHOTOS = [
  { src: "/images/gallery-1.jpg", span: "md:col-span-2 md:row-span-2", ratio: "aspect-[4/3] md:aspect-auto md:h-full" },
  { src: "/images/gallery-2.jpg", span: "", ratio: "aspect-[3/4] md:aspect-auto md:h-full" },
  { src: "/images/gallery-3.jpg", span: "", ratio: "aspect-[3/4] md:aspect-auto md:h-full" },
  { src: "/images/gallery-4.jpg", span: "md:col-span-2", ratio: "aspect-[16/9] md:aspect-auto md:h-full" },
  { src: "/images/gallery-5.jpg", span: "", ratio: "aspect-[3/4] md:aspect-auto md:h-full" },
  { src: "/images/gallery-6.jpg", span: "", ratio: "aspect-[3/4] md:aspect-auto md:h-full" },
  { src: "/images/gallery-7.jpg", span: "md:col-span-2", ratio: "aspect-[16/9] md:aspect-auto md:h-full" },
  { src: "/images/gallery-8.jpg", span: "", ratio: "aspect-[3/4] md:aspect-auto md:h-full" },
  { src: "/images/gallery-9.jpg", span: "", ratio: "aspect-[3/4] md:aspect-auto md:h-full" },
];

export default function Gallery() {
  const { t } = useLang();
  const captions = t("gallery.captions");
  const [custom, setCustom] = useState([]);

  useEffect(() => {
    axios.get(`${API}/gallery`).then((r) => setCustom(r.data.positions || [])).catch(() => {});
  }, []);

  return (
    <section id="gallery" data-testid="gallery-section" className="px-5 py-24 sm:px-8 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <Reveal className="mb-14 flex flex-wrap items-end justify-between gap-6">
          <div>
            <Eyebrow>{t("gallery.eyebrow")}</Eyebrow>
            <h2 className="font-display mt-6 text-3xl font-light tracking-tight sm:text-4xl lg:text-5xl">
              {t("gallery.h1")}<span className="italic" style={{ color: "var(--accent-gold)" }}>{t("gallery.h2")}</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed" style={{ color: "var(--text-secondary)" }}>
            {t("gallery.intro")}
          </p>
        </Reveal>

        <div className="grid auto-rows-fr gap-4 md:grid-cols-4">
          {PHOTOS.map((p, i) => {
            const src = custom.includes(i + 1) ? `${API}/gallery/image/${i + 1}` : p.src;
            return (
              <Reveal key={p.src} delay={i * 0.07} className={p.span}>
                <figure
                  data-testid={`gallery-image-${i + 1}`}
                  className={`group relative h-full w-full overflow-hidden rounded-2xl border ${p.span}`}
                  style={{ borderColor: "var(--border-delicate)" }}
                >
                  <img
                    src={src}
                    alt={`Maa Prem Mahima — ${captions[i]}`}
                    loading="lazy"
                    className={`${p.ratio} w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-[1.05]`}
                  />
                  <figcaption
                    className="absolute inset-x-0 bottom-0 translate-y-2 px-5 py-4 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100"
                    style={{ background: "linear-gradient(to top, rgba(0,0,0,0.55), transparent)" }}
                  >
                    <span className="font-mono-alt text-[10px] uppercase tracking-[0.25em] text-white/90">
                      {captions[i]}
                    </span>
                  </figcaption>
                </figure>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
